import { ProcessingStatus } from '@/core/models/knowledge-base-collection.model';
import { Chip } from '@mui/material';

type StatusBadgeProps = {
    status: ProcessingStatus;
};

const statusMap: Record<ProcessingStatus, { label: string; color: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' }> = {
    [ProcessingStatus.PENDING]: { label: 'Pending', color: 'warning' },
    [ProcessingStatus.PROCESSING]: { label: 'Processing', color: 'info' },
    [ProcessingStatus.COMPLETED]: { label: 'Completed', color: 'success' },
    [ProcessingStatus.FAILED]: { label: 'Failed', color: 'error' },
    [ProcessingStatus.DELETED]: { label: 'Deleted', color: 'default' },
};

function StatusBadge({ status }: StatusBadgeProps) {
    const { label, color } = statusMap[status] || { label: 'Unknown', color: 'default' };

    return <Chip label={label} color={color} size="small" />;
}

export default StatusBadge; 